module.exports = __webpack_public_path__ + "static/img/pic_13@2x.71d367af.png";